import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { TranslateModule } from "@ngx-translate/core";
import { TeamSettingsPreviewComponent } from "./preview.component";
import { TeamSettingsWebPreviewComponent } from "./preview/web-preview-content.component";
import { TeamSettingsMobilePreviewComponent } from "./preview/mobile-preview-content.component";
import { HubspotModule } from "@onsip/web/features/shared/components/hubspot/hubspot.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { TeamPageModule } from "@onsip/web/features/teamPage/team-page.module";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { TeamSettingsPreviewContentComponent } from "./preview/preview-content.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HubspotModule,
    TranslateModule,
    RouterModule,
    TeamPageModule,
    PipesModule
  ],
  declarations: [
    TeamSettingsPreviewComponent,
    TeamSettingsMobilePreviewComponent,
    TeamSettingsWebPreviewComponent,
    TeamSettingsPreviewContentComponent
  ],
  exports: [TeamSettingsPreviewComponent]
})
export class TeamSettingsPreviewModule {}
